// extracted by mini-css-extract-plugin
module.exports = {"root":"InboxProviderResponseRate_root__3f4ae"};